import { usePermissions } from "../../../server/auth/use-permissions";
import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabasePermissionsService } from "../../employees/server/supabase-person-service";

import type { DatabaseWithOptions } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";
import type { PostgrestClient } from "@supabase/postgrest-js";

export interface MomentRestrictions {
  segment: UUID[];
  email_from: UUID[];
}

export function useMomentRestrictions(): ReturnType<typeof useSupabaseLoader<MomentRestrictions>> {
  const { ce_admin } = usePermissions();

  return useSupabaseLoader(
    async ({ supabase }) => getMomentRestrictions(ce_admin, supabase),
    [ce_admin],
  );
}

export async function getMomentRestrictions(
  ce_admin: boolean,
  supabase: PostgrestClient<DatabaseWithOptions["db"], DatabaseWithOptions["options"], "public">,
): Promise<MomentRestrictions> {
  if (ce_admin) return { segment: [], email_from: [] };

  const { data, error } = await new SupabasePermissionsService(
    supabase,
  ).getCurrentUserPermissions();

  if (error) {
    console.error("Error fetching moment restrictions", error);
    return { segment: [], email_from: [] };
  }

  return {
    segment: data?.segment_deny_list ?? [],
    email_from: data?.email_from_deny_list ?? [],
  };
}
